import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { StoriesCarousel } from './StoriesCarousel';
import { StoryViewer } from './StoryViewer';
import { CreateStoryDialog } from './CreateStoryDialog';
import { useStories } from '@/hooks/useStories';
import { useAuth } from '@/hooks/useAuth';
import { useI18n } from '@/i18n/LanguageContext';
export const Stories = () => {
  const [selectedStoryIndex, setSelectedStoryIndex] = useState<number | null>(null);
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const { t } = useI18n();
  const {
    stories,
    loading,
    viewStory
  } = useStories();
  const {
    isAdmin
  } = useAuth();
  const handleStoryClick = (index: number) => {
    if (index < stories.length) {
      viewStory(stories[index].id);
      setSelectedStoryIndex(index);
    }
  };
  const handleCloseViewer = () => {
    setSelectedStoryIndex(null);
  };
  const handleNextStory = () => {
    if (selectedStoryIndex !== null && selectedStoryIndex < stories.length - 1) {
      const nextIndex = selectedStoryIndex + 1;
      viewStory(stories[nextIndex].id);
      setSelectedStoryIndex(nextIndex);
    }
  };
  const handlePrevStory = () => {
    if (selectedStoryIndex !== null && selectedStoryIndex > 0) {
      const prevIndex = selectedStoryIndex - 1;
      viewStory(stories[prevIndex].id);
      setSelectedStoryIndex(prevIndex);
    }
  };

  // If no stories, don't show the Stories section at all
  if (!loading && stories.length === 0) {
    return null;
  }

  // If still loading and no stories yet, also don't show
  if (loading && stories.length === 0) {
    return null;
  }
  if (loading) {
    return <section className="app-section bg-background">
        <div className="app-container">
          <div className="flex items-center justify-between mb-8">
            <h2 className="section-title">{t.stories.title}</h2>
          </div>
          <div className="w-full overflow-hidden">
            <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
              {[...Array(5)].map((_, i) => <div key={i} className="flex-shrink-0 w-20 h-20 rounded-full bg-muted animate-pulse" />)}
            </div>
          </div>
        </div>
      </section>;
  }
    return <>
      <section className="app-section bg-background">
        <div className="app-container">
          <div className="flex items-center justify-between mb-8">
            <h2 className="section-title">{t.stories.title}</h2>
            {isAdmin && <Button onClick={() => setShowCreateDialog(true)} size="sm" className="gap-2">
                <Plus size={16} />
                {t.stories.add}
              </Button>}
          </div>

          {stories.length > 0 ? <StoriesCarousel stories={stories} onStoryClick={handleStoryClick} /> : <div className="text-center py-12">
              <p className="text-muted-foreground mb-4">
                {t.stories.empty}
              </p>
               {isAdmin && <Button onClick={() => setShowCreateDialog(true)} className="gap-2">
                   <Plus size={16} />
                   {t.stories.createFirst}
                 </Button>}
            </div>}
        </div>
      </section>

      {selectedStoryIndex !== null && <StoryViewer stories={stories} currentIndex={selectedStoryIndex} onClose={handleCloseViewer} onNext={handleNextStory} onPrev={handlePrevStory} />}

      {showCreateDialog && <CreateStoryDialog open={showCreateDialog} onOpenChange={setShowCreateDialog} />}
    </>;
};